const SCREEN_SIZES = {
  full: [
    { min: 1700, value: 1500 },
    { min: 1286, value: 1250 },
    { min: 0, value: 880 }
  ],
  normal: [
    { min: 1700, value: 1250 },
    { min: 1286, value: 880 },
    { min: 0, value: 680 }
  ]
}

const checkWidthScreen = (widthScreen, callback, fullWidth) => {
  if (typeof callback === 'function') callback()

  const sizes = fullWidth ? SCREEN_SIZES.full : SCREEN_SIZES.normal
  for (const { min, value } of sizes) {
    if (widthScreen > min) return value
  }

  return sizes[sizes.length - 1].value
}

export { checkWidthScreen }
